/**
 * Logger utility that only outputs full details in development mode.
 * In production, errors are logged with safe metadata only —
 * no stack traces, no API details, no raw error objects.
 */

const isDev = import.meta.env.DEV;

/** Extract only safe, non-sensitive metadata from an error */
const safeErrorSummary = (err: unknown): string => {
  if (err instanceof Error) {
    return err.name || 'Error';
  }
  return 'UnknownError';
};

export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  error: (message: string, ...args: unknown[]) => {
    if (isDev) {
      console.error(message, ...args);
    } else {
      // In production, log only the label + error class name
      const errorType = args.length > 0 ? safeErrorSummary(args[0]) : '';
      console.error(`[Error] ${message}`, errorType ? `(${errorType})` : '');
    }
  },
  debug: (...args: unknown[]) => {
    if (isDev) console.debug(...args);
  },
};
